export enum MessageActionType {
  CLOSE,
  REGISTER,
  DEREGISTER,
  IDLE,
  ACTIVE,
  PROMPT,
  START,
  MESSAGE,
  RESET,
}
